document.addEventListener("DOMContentLoaded", (event) => {
  document.dispatchEvent(
    new CustomEvent("custom:loadBuilder", {
      detail: { data: build },
    })
  );
});


let build = {
  selectors: document.querySelectorAll(".js-build-variants"),
  inputs: document.querySelectorAll(".js-build-input"),
  products: document.querySelectorAll(".js-build-product-layout"),
  variants: document.querySelectorAll(".js-build-variants"),
  defaults: document.querySelectorAll("[data-product-position]"),
  inputs: document.querySelectorAll(".js-build-input"),
  skus: document.querySelectorAll("[data-sku-id]"),
};

let cart = {
  button: document.querySelector(".js-build-add-to-cart"),
  products: document.querySelectorAll(".js-build-default, .js-build-product-layout"),
  activeProducts: document.querySelectorAll(".js-active-product"),
};

let cartArray = [];

function showElement(el) {
  el.classList.remove("hide");
}

function hideElement(el) {
  el.classList.add("hide");
}

// Page loaded functions
document.addEventListener("custom:loadBuilder", (e) => {
  productPageLoaded();
});

async function productPageLoaded() {
  try {
    await buildProductChange();
    await setActiveProducts();
  } catch (err) {
    console.log(err);
  }
}

function buildProductChange() {
  build.selectors.forEach((selector) => {
    selector.addEventListener("click", (e) => {
      document.dispatchEvent(
        new CustomEvent("custom:productChanged", {
          detail: { product: selector },
        })
      );
    });
  });
}

function setActiveProducts() {
  build.products.forEach((product) => {
    let position = product.dataset.productPosition;
    if (position != "default") {      
      setTimeout(() => {
        hideElement(product);
      }, "1000");
    }
    else if (position == 'default'){
     loadProductInputs(product.dataset.productId) 
    }
  });
}

function loadProductInputs(productId) {
  build.inputs.forEach((input) => {
    let id = input.dataset.id;
    if(productId == id){
      input.checked = true;   
    }
  });
}

// Product changed functions
document.addEventListener("custom:productChanged", (e) => {
  let product = e.detail.product;

  let data = {
    id: product.dataset.productId,
    option: product.dataset.optionName,
    label: product.dataset.productLabel,
    input: product.querySelector('input[type="radio"]'),
  };

  productsUpdated(data, product);
});

async function productsUpdated(data, product) {
  try {
    await updateActiveProducts(data.id, data.option);
    await updateSelectedProducts(data, product)
  } catch (err) {
    console.log(err);
  }
}

function updateActiveProducts(selectorId, selectorOption) {
  build.products.forEach((product) => {
    let option = product.dataset.optionName;
    let id = product.dataset.productId;

    if (option == selectorOption) {
      if (id == selectorId) {
        showElement(product);
        product.classList.add("js-active-product");
      } else {
        hideElement(product);
        product.classList.remove("js-active-product");
      }
    }
  });
}

function updateSelectedProducts(data, product) {
  build.selectors.forEach((selector)=>{
    let id = selector.dataset.productId
    let input = selector.querySelector('input[type="radio"]')
    if (id == data.id) {
      input.checked = true;
    }
  })
}

// Add to cart functions
cart.button.addEventListener("click", () => {
  addToCart();
});

async function addToCart() {
  try {
    await setCartData();
    await buildCart();
    await clearCart();
  } catch (err) {
    console.log(err);
  }
}

function setCartData() {
  cart.products.forEach((product) => {
    let sku = product.querySelector("[data-sku-id]").textContent;
    if (product.classList.contains("js-active-product")) {
      getCartData(sku);
    }
  });
}

function getCartData(activeSku) {
  build.variants.forEach((variant) => {
    let sku = variant.dataset.variantSku;
    let id = variant.dataset.variantId;

    let data = {
      id: id,
      quantity: 1,
      properties: {
        value: "Build Your Own DIN",
      },
    };

    if (activeSku == sku) {
      cartArray.push(data);
    }
  });
}

function buildCart() {
  let data = cartArray.filter(
    (thing, index, self) =>
      index ===
      self.findIndex((t) => JSON.stringify(t) === JSON.stringify(thing))
  );
  let formData = {
    items: data,
  };
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json();
    })
    .then((response) => {
      document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
      document.dispatchEvent(new CustomEvent("cart:build"));
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function clearCart() {
  cartArray = [];
}
